import {createReducer, on} from "@ngrx/store";
import * as ResearchesActions from './researches.actions';
import {Research} from "../../models/Research";
export const ResearchesFeatureKey = 'researches';
export const ResearchesInitialState: Research[] = null;
export const ResearchesReducer = createReducer<Research[] | null>(
  ResearchesInitialState,
  on(ResearchesActions.update, (_state, { researches }) => researches),
);
